import { routesConfig } from '../routes/routesConfig';

export const getScreenName = () =>
  routesConfig[window.location.pathname]?.screenName ||
  window.location.pathname.split('/').join(' ');
